import { gql } from "@apollo/client";
export default gql`
  mutation ShareReports($input: ReportShareInput!) {
    shareReports(input: $input)
  }
`;
